import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import "../../assets/css/AddressDetails.css";
import SideBar from "../../Components/SideBar/SideBar";
import { Link } from "react-router-dom";
import TopBar from "../../Components/SideBar/TopBar";
import {
  EditAddress,
  GetAllAddress,
  PostAddressApi,
  PostDeleteAddress,
  PostMakeDefaultAddress,
  UpdateProfile,
} from "../../network/Network";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import NoRecord from "../../Components/NoRecord/NoRecord";
import { AllAddress } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import swal from "sweetalert";

function MyAddress() {
  const dispatch = useDispatch();
  const Token = useSelector((state) => state.AuthReducer.token);
  const [newFile, setNewFile] = useState("");
  const [fileupload, setFileupload] = useState("");
  const [uploadLoading, setUploadLoading] = useState(false);
  const [editState, setEditState] = useState(false);
  const [passLoading, setPassLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [firstName, setFirstName] = useState("John");
  const [lastName, setLastName] = useState("Doe");
  const [phone, setPhone] = useState("");

  const [loading, setLoading] = useState(false);

  const [address, setAddress] = useState("");
  const [appartment, setAppartment] = useState("");
  const [city, setCity] = useState("");
  const [zip, setZip] = useState("");
  const [country, setCountry] = useState("");
  const [userState, setUserState] = useState("");

  const [postAddress, setPostAddress] = useState([]);
  const [selectedAddress, setSelectedPostAddress] = useState();
  const [editAddress, setEditAddress] = useState(false);

  const handleImageUpload = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      setNewFile(file);
      setFileupload(reader.result);
    };
    reader.readAsDataURL(file);
    setUploadLoading(true);
  };

  const EditProfile = (e) => {
    e.preventDefault();
    setEditState(!editState);
  };

  const [userAddress, setUserAddress] = useState([]);
  const [spinLoad, setSpinLoad] = useState(false);

  useEffect(() => {
    setSpinLoad(true);
    GetAllAddress(Token)
      .then((res) => {
        dispatch(AllAddress(res?.data));
        setUserAddress(res?.data);
        setSpinLoad(false);
      })
      .catch((err) => {
        setSpinLoad(false);
      });
  }, [postAddress]);

  const MakeDefault_Handler = (e, id) => {
    e.preventDefault();
    let data = {
      address_id: id,
    };
    PostMakeDefaultAddress(data, Token)
      .then((res) => {
        toast.success(res?.data?.message);
        setPostAddress(res?.data);
      })
      .catch((err) => {});
  };

  const DeleteAddressMethod = (id, index) => {
    setSpinLoad(true);
    let data = {
      address_id: id,
      _method: "delete",
    };
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this Address!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        PostDeleteAddress(data, Token)
          .then((res) => {
            setUserAddress((preVal) => {
              return [...preVal.filter((val) => val?.id !== id)];
            });
            swal(res?.data?.message, {
              icon: "success",
            });
            setSpinLoad(false);
          })
          .catch((err) => {
            setSpinLoad(false);
          });
      } else {
        swal("Your Address is safe!");
        setSpinLoad(false);
      }
    });
  };

  const StoreAddressForUpdate = (e, item) => {
    window.scrollTo(0, 0);
    e.preventDefault();
    setEditAddress(true);
    setSelectedPostAddress(item);
    setAddress(item?.address);
    setAppartment(item?.appartment);
    setCity(item?.city);
    setZip(item?.zip);
    setPhone(item?.phone);
    setCountry(item?.country);
    setUserState(item?.state);
  };

  const EditAddressHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    if (
      !address ||
      !appartment ||
      !city ||
      !zip ||
      !phone ||
      !country ||
      !userState
    ) {
      toast.error("Please Enter All Fields");
      setLoading(false);
      return;
    }
    if (phone?.length < 10) {
      toast.error("The phone no must be at least 10 characters");
      setLoading(false);
      return;
    }
    let data = new FormData();
    data.append("address", address);
    data.append("appartment", appartment);
    data.append("city", city);
    data.append("zip", zip);
    data.append("phone", phone);
    data.append("country", country);
    data.append("state", userState);
    data.append("address_id", selectedAddress?.id);
    EditAddress(data, Token)
      .then((res) => {
        toast.success(res?.data?.message);
        setPostAddress(res?.data);
        setEditAddress(false);
        setLoading(false);
        setSelectedPostAddress("");
        setAddress("");
        setAppartment("");
        setPhone("");
        setCity("");
        setCountry("");
        setUserState("");
        setZip("");
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const AddAddressHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    if (
      !address ||
      !appartment ||
      !city ||
      !zip ||
      !phone ||
      !country ||
      !userState
    ) {
      toast.error("Please Enter All Fields");
      setLoading(false);
      return;
    }
    if (phone?.length < 10) {
      toast.error("The phone no must be at least 10 characters");
      setLoading(false);
      return;
    }
    let data = new FormData();
    data.append("address", address);
    data.append("appartment", appartment);
    data.append("city", city);
    data.append("zip", zip);
    data.append("phone", phone);
    data.append("country", country);
    data.append("state", userState);
    PostAddressApi(data, Token)
      .then((res) => {
        toast.success(res?.data?.message);
        setPostAddress(res?.data);
        setLoading(false);
        setAddress("");
        setAppartment("");
        setPhone("");
        setCity("");
        setCountry("");
        setUserState("");
        setZip("");
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <>
      <Header />

      {/* <!-- Universal Banner Sec End Here --> */}
      <section className="profile myaddress_page">
        <div className="container">
          <div className="row profile-row set-row">
            <SideBar
              uploadLoading={uploadLoading}
              fileupload={fileupload}
              handleImageUpload={handleImageUpload}
            />
            <div className="col-lg-9">
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade active show"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <TopBar />

                  {!editState ? (
                    <div className="row">
                      <div className="col-lg-12 ">
                        <div className="container-fluid">
                          <div className="saved-address-heading">
                            <div>
                              <h3 className="form-heading heading-top-cont">
                                Addresses
                              </h3>
                            </div>
                            {/* <div>
														<Link to="#">Edit</Link>
													</div> */}
                          </div>
                          <form>
                            <div className="adddress-form">
                              <div className="namediv ">
                                <div className="row">
                                  <div className="col-lg-4">
                                    <div className="firstname">
                                      <label htmlFor="address">Address</label>
                                      <input
                                        value={address}
                                        onChange={(e) =>
                                          setAddress(e.target.value)
                                        }
                                        type="text"
                                        id="address"
                                        placeholder="ABC Street Lorem Ipsum"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="firstname">
                                      <label htmlFor="address">Phone</label>
                                      <input
                                        value={phone}
                                        onChange={(e) =>
                                          setPhone(e.target.value)
                                        }
                                        type="text"
                                        id="address"
                                        placeholder="+1-234-567-890"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="lastname">
                                      <label htmlFor="suite">
                                        Suite,Apartment,etc
                                      </label>
                                      <input
                                        type="text"
                                        id="suite"
                                        value={appartment}
                                        onChange={(e) =>
                                          setAppartment(e.target.value)
                                        }
                                        placeholder="Everest"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="namediv">
                                <div className="row">
                                  <div className="col-lg-2">
                                    <div className="firstname">
                                      <label htmlFor="city">City</label>
                                      <input
                                        value={city}
                                        onChange={(e) =>
                                          setCity(e.target.value)
                                        }
                                        type="text"
                                        id="city"
                                        placeholder="New York"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-2">
                                    <div className="lastname">
                                      <label htmlFor="state">State</label>
                                      <input
                                        value={userState}
                                        onChange={(e) =>
                                          setUserState(e.target.value)
                                        }
                                        type="text"
                                        id="state"
                                        placeholder="Arizona"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-2">
                                    <div className="lastname">
                                      <label htmlFor="country">Country</label>
                                      <input
                                        type="text"
                                        id="country"
                                        placeholder="USA"
                                        value={country}
                                        onChange={(e) =>
                                          setCountry(e.target.value)
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-2">
                                    <div className="lastname">
                                      <label htmlFor="zip">Zip Code</label>
                                      <input
                                        type="text"
                                        id="zip"
                                        placeholder="98465"
                                        value={zip}
                                        onChange={(e) => setZip(e.target.value)}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-12 mt-3 text-left">
                                    {selectedAddress ? (
                                      <button
                                        disabled={loading}
                                        onClick={(e) => EditAddressHandler(e)}
                                        className="btn btn-large logout-btn text-transform-none"
                                      >
                                        {" "}
                                        {loading
                                          ? "Loading..."
                                          : "Update Address"}
                                      </button>
                                    ) : (
                                      <button
                                        disabled={loading}
                                        onClick={(e) => AddAddressHandler(e)}
                                        className="btn btn-large logout-btn text-transform-none"
                                      >
                                        {" "}
                                        {loading
                                          ? "Loading..."
                                          : "Save Address"}
                                      </button>
                                    )}

                                    {/* </div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                          <div className="save-address headbtn address23">
                            {/* <div className="heading">
                              <h3 className="form-heading heading-top-cont">
                                Saved Addresses
                              </h3>
                            </div> */}
                            {/* Saved Address  */}
                            {/* <div className="row">
                              {spinLoad ? (
                                <>
                                  {[0, 1, 2, 3, 4, 5]?.map((item, index) => {
                                    return (
                                      <div
                                        className="col-md-4 mt-3"
                                        key={index}
                                      >
                                        <Skeleton count={5} />
                                      </div>
                                    );
                                  })}
                                </>
                              ) : (
                                <>
                                  {userAddress?.length > 0 ? (
                                    <>
                                      <div className="col-lg-8">
                                        <label className="container">
                                          <input
                                            type="radio"
                                            checked="checked"
                                            name="radio"
                                          />
                                          <span className="checkmark">
                                            <div className="select-address">
                                              <div className="address-detail">
                                                <div className="actions">
                                                  <a href="#">
                                                    <i
                                                      className="fa fa-pencil-square-o"
                                                      aria-hidden="true"
                                                      onClick={(e) =>
                                                        EditProfile(e)
                                                      }
                                                    ></i>
                                                  </a>
                                                  <a href="#">
                                                    <i
                                                      className="fa fa-trash"
                                                      aria-hidden="true"
                                                    ></i>
                                                  </a>
                                                </div>
                                                <h5>
                                                  <span className="property">
                                                    Country:
                                                  </span>
                                                  <div className="spacer"></div>
                                                  <span className="value">
                                                    United States
                                                  </span>
                                                </h5>
                                                <h5>
                                                  <span className="property">
                                                    Address:
                                                  </span>
                                                  <div className="spacer"></div>
                                                  <span className="value">
                                                    10515 Fox Ave Fairdale,
                                                    Kentucky(KY), 40118
                                                  </span>
                                                </h5>
                                                <h5>
                                                  <span className="property">
                                                    Phone:
                                                  </span>
                                                  <div className="spacer"></div>
                                                  <span className="value">
                                                    +44-123-456-789
                                                  </span>
                                                </h5>
                                                <h5>
                                                  <span className="property">
                                                    State:
                                                  </span>
                                                  <div className="spacer"></div>
                                                  <span className="value">
                                                    Texas
                                                  </span>
                                                </h5>
                                                <div className="deafult">
                                                  <h5>Use as default</h5>
                                                  <span className="dot"></span>
                                                </div>
                                              </div>
                                            </div>
                                          </span>
                                        </label>
                                        <label className="container">
                                          <input type="radio" name="radio" />
                                          <span className="checkmark">
                                            <div className="select-address">
                                              <div className="address-detail">
                                                <div className="actions">
                                                  <a href="#">
                                                    <i
                                                      className="fa fa-pencil-square-o"
                                                      aria-hidden="true"
                                                      onClick={(e) =>
                                                        EditProfile(e)
                                                      }
                                                    ></i>
                                                  </a>
                                                  <a href="#">
                                                    <i
                                                      className="fa fa-trash"
                                                      aria-hidden="true"
                                                    ></i>
                                                  </a>
                                                </div>
                                                <h5>
                                                  <span className="property">
                                                    Country:
                                                  </span>
                                                  <div className="spacer"></div>
                                                  <span className="value">
                                                    United States
                                                  </span>
                                                </h5>
                                                <h5>
                                                  <span className="property">
                                                    Address:
                                                  </span>
                                                  <div className="spacer"></div>
                                                  <span className="value">
                                                    10515 Fox Ave Fairdale,
                                                    Kentucky(KY), 40118
                                                  </span>
                                                </h5>
                                                <h5>
                                                  <span className="property">
                                                    Phone:
                                                  </span>
                                                  <div className="spacer"></div>
                                                  <span className="value">
                                                    +44-123-456-789
                                                  </span>
                                                </h5>
                                                <h5>
                                                  <span className="property">
                                                    State:
                                                  </span>
                                                  <div className="spacer"></div>
                                                  <span className="value">
                                                    Texas
                                                  </span>
                                                </h5>
                                                <div className="deafult">
                                                  <h5>Use as default</h5>
                                                  <span className="dot"></span>
                                                </div>
                                              </div>
                                            </div>
                                          </span>
                                        </label>
                                      </div>
                                      <div className="col-lg-4"></div>
                                    </>
                                  ) : (
                                    <NoRecord />
                                  )}
                                </>
                              )}
                            </div> */}
                            <div className="save-address">
                              <div className="heading">
                                <h3>Saved Addresses</h3>
                              </div>
                              {/* <!-- Saved Address --> */}
                              {spinLoad ? (
                                <>
                                  {[0, 1, 2, 3, 4, 5, 7, 8, 9]?.map(
                                    (item, index) => {
                                      return (
                                        <div
                                          className="col-md-12 mt-3"
                                          key={index}
                                        >
                                          <Skeleton count={5} />
                                        </div>
                                      );
                                    }
                                  )}
                                </>
                              ) : userAddress.length > 0 ? (
                                <>
                                  {userAddress?.map((item, index) => {
                                    return (
                                      <label className="container" key={index}>
                                        <input
                                          type="radio"
                                          checked={
                                            item?.default == 1 ? true : false
                                          }
                                          name="radio"
                                        />
                                        <span className="checkmark">
                                          <div className="select-address">
                                            <div className="address-detail">
                                              <div className="actions">
                                                <a
                                                  onClick={(e) =>
                                                    StoreAddressForUpdate(
                                                      e,
                                                      item
                                                    )
                                                  }
                                                  className="editAddress edit cursor_pointer"
                                                >
                                                  <i
                                                    className="fa fa-pencil-square-o"
                                                    aria-hidden="true"
                                                  ></i>
                                                </a>
                                                <a
                                                  onClick={(e) =>
                                                    DeleteAddressMethod(
                                                      item?.id,
                                                      index
                                                    )
                                                  }
                                                  className="deleteAddress cursor_pointer"
                                                >
                                                  <i
                                                    className="fa fa-trash"
                                                    aria-hidden="true"
                                                  ></i>
                                                </a>
                                              </div>
                                              <h5>
                                                <span className="property">
                                                  Country:
                                                </span>
                                                <div className="spacer"></div>
                                                <span className="value">
                                                  {item?.country}
                                                </span>
                                              </h5>
                                              <h5>
                                                <span className="property">
                                                  Address:
                                                </span>
                                                <div className="spacer"></div>
                                                <span className="value">
                                                  {item?.address}
                                                </span>
                                              </h5>
                                              <h5>
                                                <span className="property">
                                                  Phone:
                                                </span>
                                                <div className="spacer"></div>
                                                <span className="value">
                                                  {item?.phone}
                                                </span>
                                              </h5>
                                              <h5>
                                                <span className="property">
                                                  State:
                                                </span>
                                                <div className="spacer"></div>
                                                <span className="value">
                                                  {item?.state}
                                                </span>
                                              </h5>
                                              <div
                                                className="deafult"
                                                onClick={(e) =>
                                                  MakeDefault_Handler(
                                                    e,
                                                    item?.id
                                                  )
                                                }
                                              >
                                                <h5>Use as default</h5>
                                                <span className="dot"></span>
                                              </div>
                                            </div>
                                          </div>
                                        </span>
                                      </label>
                                    );
                                  })}
                                </>
                              ) : (
                                <NoRecord />
                              )}

                              {/* <!-- Saved Address --> */}
                            </div>
                            {/* Saved Address */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col-lg-12">
                      <div className="account-form-wrapper">
                        <div className="Accounts2">
                          <h3 className="form-heading">Account</h3>
                          <div>
                            <button
                              className="btn logout-btn2 mr-2"
                              onClick={(e) => EditProfile(e)}
                              disabled={editLoading}
                            >
                              SAVE CHANGES &nbsp;
                            </button>
                          </div>
                        </div>
                        <form action="">
                          <div className="form-group row">
                            <div className="col-lg-6">
                              <label for="FirstName">Address</label>
                              <input
                                type="text"
                                className="form-control input_data"
                                value="+1-234-567-980"
                                onChange={(e) => setFirstName(e.target.value)}
                              />
                            </div>
                            <div className="col-lg-6">
                              <label for="lastName">Suite,Apartment,etc</label>
                              <input
                                type="text"
                                className="form-control input_data"
                                value="Everest@gmail.com"
                                onChange={(e) => setLastName(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-lg-6">
                              <label for="PhoneNumber">City</label>
                              <input
                                type="text"
                                className="form-control input_data"
                                value="New York"
                                onChange={(e) => setPhone(e.target.value)}
                              />
                            </div>
                            <div className="col-lg-6">
                              <label for="PhoneNumber">State</label>
                              <input
                                type="text"
                                className="form-control input_data"
                                value="Arizona"
                                onChange={(e) => setPhone(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-lg-6">
                              <label for="PhoneNumber">Country</label>
                              <input
                                type="text"
                                className="form-control input_data"
                                value="USA"
                                onChange={(e) => setPhone(e.target.value)}
                              />
                            </div>
                            <div className="col-lg-6">
                              <label for="PhoneNumber">Zip Code</label>
                              <input
                                type="number"
                                className="form-control input_data"
                                value="98465"
                                onChange={(e) => setPhone(e.target.value)}
                              />
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default MyAddress;
